module.exports = __webpack_public_path__ + "static/logo_MYPR-3226ff843b4be1e4afe65d3683c656a5.png";